import { Navigate } from "react-router-dom";
// import { createSelector } from "reselect";
// import { useSelector } from "react-redux";
import { sidebarItems } from "data/data";
const ProtectedRoute = ({ constant, children }: { constant: string; children: JSX.Element }) => {

  const selectLoginState = (state: any) => state.Login;

  // const selectUserData = createSelector(selectLoginState, (login) => ({
  //   useraccessrights: login.useraccessrights
  // }));


  const  useraccessrights  = sidebarItems


  const allowed = useraccessrights.find((item: any) => item.constant === constant);  console.log(constant, allowed);
  return allowed ? children : <Navigate to="/explore-courses" replace />;
};

export default ProtectedRoute;
